export default "__VITE_ASSET__81616cdd__"